import { Switch } from '../../../../../../../components/switch/switch';
import { useLang } from '../../../../../../../hooks/use-lang';
import { FormElementType } from '../../../../../../../store/api/forms-api';
import { useFormStore } from '../../../../../../../store/use-form-store';
import { useInputLangStore } from '../../../../../../../store/use-input-lang-store';

interface Props {
  formElement?: Partial<FormElementType>;
}

export const FormCreateSwitch = ({ formElement }: Props) => {
  const { getLocale } = useLang();
  const { newElement } = useFormStore();
  const { language } = useInputLangStore();

  const sublabel = formElement ? formElement.info?.helper_text : newElement?.info?.helper_text;
  const helper = formElement ? formElement.info?.helper : newElement?.info?.helper;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Switch isOn={false} onToggle={() => {}} />
      {helper === 'sublabel' && <label>{getLocale(sublabel, language)}</label>}
    </div>
  );
};
